export const getLocalizationObj = (input, language) => {
  if (language === 'de') {
    return input;
  }
  if (input.localizations) {
    return input.localizations[0];
  }
  return input;
};
